import React, { useEffect, useState, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import Select from "../FormComponents/Select/Select";
import Input from "../FormComponents/Input/Input";
import NumberFormat from "react-number-format";
import Spinner from "react-bootstrap/Spinner";
import _, { set } from "lodash";

var formatter = new Intl.NumberFormat("en-US", {
	style: "currency",
	currency: "USD",
});

const PricingQuote = (props) => {
	const { amount, renewalId, renewalData } = props;
	const [physicalProtection, setPhysicalProtection] = useState("");
	const [pricingOption, setPricingOption] = useState("");
	const [physicalValue, setPhysicalValue] = useState("");
	const loadingQuote = useSelector((state) => state.LoadingQuote);
	const dispatch = useDispatch();

	const pricingOptions = [
		<option value={"annual"}>Yearly</option>,
		<option value={"monthly"}>Monthly</option>,
	];

	const getPhysicalPrice = (amount) => {
		if (amount && amount.products && amount.products.length > 0) {
			const physicalProduct = amount.products.find(
				(product) => product.id === 1
			);
			return formatter.format(_.get(physicalProduct, `price`, ""));
		}
	};

	useEffect(() => {
		setPhysicalValue(getPhysicalPrice(amount));
	}, [amount]);

	const debounceSearch = useRef(
		_.debounce((physicalProtection) => {
			handleChangeProtection(physicalProtection);
		}, 1000)
	);

	useEffect(() => {
		if (physicalProtection) {
			setPhysicalValue(physicalProtection);
			debounceSearch.current(physicalProtection);
		}
	}, [physicalProtection]);

	function getMeta(metaName) {
		const metas = document.getElementsByTagName("meta");

		for (let i = 0; i < metas.length; i++) {
			if (metas[i].getAttribute("name") === metaName) {
				return metas[i].getAttribute("content");
			}
		}

		return "";
	}

	function handleChangeProtection(physicalProtection) {
		dispatch({
			type: "SET_LOADING_QUOTE",
			payload: true,
		});
		const headers = new Headers({
			"X-CSRF-Token": getMeta("csrf-token"),
			"X-Requested-With": XMLHttpRequest,
			Accept: "application/json",
			"Content-Type": "application/json",
		});

		const formatValue = physicalProtection.replace(/[^0-9.]/g, "").slice(0, -3);

		const requestOptions = {
			method: "POST",
			headers,
			body: JSON.stringify({
				physical_damage_value: formatValue,
			}),
		};
		fetch(`/api/v2/quotes/${renewalId}/change_premium_value`, requestOptions)
			.then((response) => response.json())
			.then((data) => {
				dispatch({
					type: "SET_QUOTE_DATA",
					payload: data.quote,
				});
				dispatch({
					type: "SET_LOADING_QUOTE",
					payload: false,
				});
			});
	}

	const changePricingOption = (value) => {
		setPricingOption(value);
		dispatch({
			type: "SET_LOADING_MONTHLY",
			payload: true,
		});
		const requestOptions = {
			method: "PUT",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify({ ...renewalData, payment_kind: value }),
		};
		fetch(`/api/v2/quotes/${renewalId}`, requestOptions)
			.then((response) => response.json())
			.then((data) => {
				dispatch({
					type: "SET_QUOTE_DATA",
					payload: data.quote,
				});
			});
	};

	return (
		<>
			<div className="col ml-4 otmt-2">
				<h2>Pricing</h2>
			</div>
			<div className="d-flex flex-column justify-content-center">
				<div className="col-12">
					<div className="col-md-6 mt-3">
						<Select
							classSelect="form-control"
							options={pricingOptions}
							label="pricing option"
							classLabel="h5 text-uppercase"
							val={renewalData.payment_kind ? renewalData.payment_kind : false}
							setVal={changePricingOption}
						/>
					</div>
				</div>
			</div>
			<div className="d-flex flex-column justify-content-center">
				<div className="align-items-end col-12 d-flex">
					<div className="col-md-9 mt-3">
						<p>Physical Damage Protection</p>
					</div>
					<div className="col-4 col-md-3 mt-3 pr-4 text-right">
						{loadingQuote ? (
							<Spinner animation="border" variant="primary" />
						) : (
							<NumberFormat
								className="form-control text-right"
								value={physicalValue}
								onBlur={(e) => setPhysicalProtection(e.target.value)}
								onKeyPress={(e) => {
									if (e.key === "Enter") {
										handleChangeProtection(e.target.value);
									}
								}}
								thousandSeparator={true}
								suffix=".00"
								thousandsGroupStyle="thousand"
							/>
						)}
						{/* <input
							className="form-control text-right"
							defaultValue={_.get(amount, `premium`, "")}
							onChange={(e) => setPhysicalProtection(e.target.value)}
							type="tel"
						/> */}
					</div>
				</div>
				{/* 				<div className="align-items-end col-12 d-flex">
					<div className="col-md-9 mt-3">
						<p>Liability Protection</p>
					</div>
					<div className="col-md-3 col-4 mt-3">
						<div className="input-no-border">
							<p className="text-right">$100.05</p>
						</div>
					</div>
				</div>
				<div className="align-items-end col-12 d-flex">
					<div className="col-md-9 mt-3">
						<p>Misc Property Protection</p>
					</div>
					<div className="col-md-3 col-4 mt-3">
						<div className="input-no-border">
							<p className="text-right">$100.05</p>
						</div>
					</div>
				</div> */}
				<div className="align-items-end col-12 d-flex">
					<div className="col-md-9 mt-3">
						<p>Admin Fee</p>
					</div>
					<div className="col-md-3 col-4 mt-3 text-right">
						{loadingQuote ? (
							<Spinner animation="border" variant="primary" />
						) : (
							<div className="input-no-border">
								<p className="text-right">
									{formatter.format(
										_.get(amount, `products[0].initial_admin_fee_amount`, "")
									)}
								</p>
							</div>
						)}
					</div>
				</div>
				<div className="align-items-end col-12 d-flex">
					<div className="col-md-9 mt-3">
						<p>Taxes</p>
					</div>
					<div className="col-md-3 col-4 mt-3 text-right">
						{loadingQuote ? (
							<Spinner animation="border" variant="primary" />
						) : (
							<div className="input-no-border">
								<p className="text-right">
									{formatter.format(_.get(amount, `taxes`, ""))}
								</p>
							</div>
						)}
					</div>
				</div>
				<hr
					className="softline l1 mt-2 otmt-2 col-12"
					style={{ maxWidth: "95%" }}
				/>
				{renewalData.payment_kind === "annual" && (
					<div className="align-items-end col-12 d-flex">
						<div className="col-md-9 mt-3">
							<h3 style={{ color: "#00778a" }} className="texte-uppercase">
								Yearly Total
							</h3>
						</div>
						<div className="col-md-3 col-4 mt-3">
							<div className="text-right">
								{loadingQuote ? (
									<Spinner animation="border" variant="primary" />
								) : (
									<h3 className="text-right" style={{ color: "#00778a" }}>
										{formatter.format(_.get(amount, "total", 0))}
									</h3>
								)}
							</div>
						</div>
					</div>
				)}
				{renewalData.payment_kind === "monthly" && (
					<div className="align-items-end col-12 d-flex">
						<div className="col-md-9 mt-3">
							<h3 style={{ color: "#00778a" }} className="texte-uppercase">
								Monthly Total
							</h3>
						</div>
						<div className="col-md-3 col-4 mt-3">
							<div className="text-right">
								{loadingQuote ? (
									<Spinner animation="border" variant="primary" />
								) : (
									<h3 className="text-right" style={{ color: "#00778a" }}>
										{formatter.format(
											_.get(amount, "initial_payment_amount", 0)
										)}
									</h3>
								)}
							</div>
						</div>
					</div>
				)}
			</div>
		</>
	);
};

export default PricingQuote;
